"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Calendar = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dateFns = require("date-fns");

var _enGB = _interopRequireDefault(require("date-fns/locale/en-GB"));

var _reactDatepicker = _interopRequireWildcard(require("react-datepicker"));

var _clickOutside = _interopRequireDefault(require("../../hooks/click-outside"));

var _utils = require("../../shared/utils");

var _Constant = require("./Constant");

var _images = require("../../assets/images");

var _Calendar = require("./Calendar.styles");

var _shared = require("../../shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

(0, _reactDatepicker.registerLocale)('en-GB', _enGB.default);
(0, _reactDatepicker.setDefaultLocale)('en-GB', _enGB.default);

const Calendar = ({
  initialValue,
  fixedHeight,
  onDateChange,
  yearsArray,
  numberOfYears,
  popperPlacement,
  customInput,
  zIndex,
  ...props
}) => {
  const [startDate, setStartDate] = (0, _react.useState)(initialValue);
  const [show, setShow] = (0, _react.useState)(false);
  const datePickerRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    setStartDate(initialValue);
  }, [initialValue]);
  const years = (0, _react.useMemo)(() => {
    if (!yearsArray.length) {
      const yearLength = numberOfYears > 10 ? numberOfYears : 10;
      return Array.from({
        length: yearLength
      }, (x, i) => (0, _dateFns.getYear)(new Date()) + i);
    }

    return yearsArray.slice(0, numberOfYears);
  }, [numberOfYears, yearsArray]);
  (0, _clickOutside.default)(datePickerRef, () => {
    setShow(false);
  }, show);
  const onChange = (0, _react.useCallback)((date, e) => {
    setStartDate(date);
    (0, _utils.isValidDate)(date) && onDateChange(date, e);
    e.stopPropagation();
  }, [onDateChange]);

  const handleDropdown = () => setShow(show => !show);

  const handleDatePickerClick = () => show && setShow(false);

  return /*#__PURE__*/_react.default.createElement(_Calendar.StyledDatePicker, {
    ref: datePickerRef,
    onClick: handleDatePickerClick,
    zIndex: zIndex
  }, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, _extends({}, props, {
    customInput: (0, _utils.isFunction)(customInput) ? customInput({
      value: startDate
    }) : customInput,
    popperModifiers: {
      preventOverflow: {
        enabled: false,
        escapeWithReference: false,
        boundariesElement: 'scrollParent'
      },
      hide: {
        enabled: false
      },
      flip: {
        behavior: ['bottom']
      }
    },
    popperPlacement: popperPlacement,
    formatWeekDay: x => _Constant.days[x],
    locale: "en-GB",
    renderCustomHeader: ({
      date,
      changeYear,
      decreaseMonth,
      increaseMonth
    }) => /*#__PURE__*/_react.default.createElement(_Calendar.StyledDateHeader, null, /*#__PURE__*/_react.default.createElement(_Calendar.StyledArrow, {
      "data-testid": "decrement-year",
      onClick: decreaseMonth
    }, /*#__PURE__*/_react.default.createElement(_images.LeftArrow, {
      className: "left-arrow"
    })), /*#__PURE__*/_react.default.createElement(_Calendar.StyledHeaderCenter, null, /*#__PURE__*/_react.default.createElement("label", {
      "data-testid": "year-title"
    }, `${_Constant.months[(0, _dateFns.getMonth)(date)]} ${(0, _dateFns.getYear)(date)}`), /*#__PURE__*/_react.default.createElement(_Calendar.StyledYearSection, {
      onClick: handleDropdown
    }, /*#__PURE__*/_react.default.createElement(_images.WhiteDownArrow, {
      className: "white-arrow"
    }), show && /*#__PURE__*/_react.default.createElement(_Calendar.StyledDropdown, null, years.map(option => /*#__PURE__*/_react.default.createElement(_Calendar.StyledOption, {
      key: option,
      onClick: () => changeYear(option),
      active: (0, _dateFns.getYear)(date) === option
    }, option))))), /*#__PURE__*/_react.default.createElement(_Calendar.StyledArrow, {
      "data-testid": "increment-year",
      onClick: increaseMonth
    }, /*#__PURE__*/_react.default.createElement(_images.RightArrow, {
      className: "right-arrow"
    }))),
    selected: (0, _utils.isValidDate)(startDate) && startDate,
    onChange: onChange,
    dayClassName: date => date && 'day-padding',
    fixedHeight: fixedHeight
  })));
};

exports.Calendar = Calendar;
Calendar.defaultProps = {
  initialValue: new Date(),
  fixedHeight: true,
  onDateChange: () => {},
  numberOfYears: 10,
  yearsArray: [],
  popperPlacement: 'bottom-end',
  zIndex: _shared.theme.zIndex.calendar
};
Calendar.propTypes = {
  onDateChange: _propTypes.default.func,
  fixedHeight: _propTypes.default.bool,
  numberOfYears: _propTypes.default.number,
  yearsArray: _propTypes.default.array,
  popperPlacement: _propTypes.default.oneOf(['top-start', 'top-end', 'right-start', 'right-end', 'bottom-start', 'bottom-end', 'left-start', 'left-end']),

  /** eg. new Date() */
  minDate: _propTypes.default.instanceOf(Date),

  /** eg. new Date() */
  maxDate: _propTypes.default.instanceOf(Date),

  /** eg. new Date() */
  initialValue: _propTypes.default.instanceOf(Date),

  /** ({value})=> return input element */
  customInput: _propTypes.default.func,

  /** disable calendar */
  disabled: _propTypes.default.bool,

  /** set Z index of caldenar */
  zIndex: _propTypes.default.number
};